import { Col, Empty, message, Modal, Row, Table, Tag } from 'antd';
import moment from 'moment';
import { deferredExamService } from '../../../services/deferredExam';

const DeferredExamHistory = ({
  prescriptions,
  setPrescriptions,
  serviceDetail,
  onPrescriptionCancelled,
}) => {
  const getExamNamesByIds = (examIds) => {
    if (!examIds || !serviceDetail) return '';
    return serviceDetail
      .filter(exam => examIds.includes(exam.exam_id))
      .map(exam => exam.name)
      .join(', ');
  };

  const handleCancel = (prescription) => {
    const warningMessage = prescription.state === 'sent'
      ? 'La reevaluación eliminada posterior a la firma no revierte el envío ya realizado del correo al trabajador. ¿Desea continuar?'
      : '¿Está seguro que desea eliminar esta reevaluación?';

    Modal.confirm({
      title: 'Eliminar reevaluación',
      content: warningMessage,
      okText: 'Sí, eliminar',
      cancelText: 'Cancelar',
      centered: true,
      icon: null,
      zIndex: 1060,
      className: 'deferred-exam-confirm',
      onOk: async () => {
        try {
          await deferredExamService.cancelPrescription(prescription.id);
          setPrescriptions(prev => prev.filter(item => item.id !== prescription.id));
          if (onPrescriptionCancelled) {
            onPrescriptionCancelled();
          }
          message.success({
            content: 'Reevaluación eliminada exitosamente',
            style: { marginTop: '35vh' },
          });
        } catch (error) {
          console.error(error);
          message.error({
            content: 'Error al eliminar la reevaluación',
            style: { marginTop: '35vh' },
          });
        }
      },
    });
  };

  if (prescriptions.length === 0) {
    return (
      <Empty
        description={<span className='empty-style'>No hay reevaluaciones registradas</span>}
        image={Empty.PRESENTED_IMAGE_SIMPLE}
      />
    );
  }

  return (
    <Row className='deferred-exam-content'>
      <Col lg={24}>
        <Table dataSource={prescriptions} pagination={false} rowKey="id">
          <Table.Column
            title="Fecha"
            dataIndex="created_at"
            key="created_at"
            render={(value) => moment(value).format('DD/MM/YYYY')}
          />
          <Table.Column
            title="Reevaluación"
            dataIndex="extra_data"
            key="exams"
            render={(value) => {
              const examIds = value?.[0]?.selected_exam_ids || [];
              return getExamNamesByIds(examIds);
            }}
          />
          <Table.Column
            title="Estado"
            dataIndex="state"
            key="state"
            render={(value) => {
              const stateMap = { draft: { label: 'Borrador', color: 'blue' }, sent: { label: 'Enviada', color: 'green' }, cancelled: { label: 'Eliminada', color: 'red' } };
              const stateInfo = stateMap[value] || { label: value, color: 'default' };
              return <Tag color={stateInfo.color}>{stateInfo.label}</Tag>;
            }}
          />
          <Table.Column
            title=""
            key="actions"
            render={(value, record) => (
              record.state !== 'cancelled' && (
                <span
                  className="icon-system-delete deferred-exam-delete-icon"
                  onClick={() => handleCancel(record)}
                />
              )
            )}
          />
        </Table>
      </Col>
    </Row>
  );
};

export default DeferredExamHistory;
